import {
  SET_MAP_REF,
  CLEAR_MAP_REF,
  SET_MAP_ZOOM,
  FIT_MAP_BOUNDS,
  FLY_TO,
  SET_VIEW,
} from './constants'

export default (store) => {
  let map = null

  return (dispatch) => (action) => {
    switch (action.type) {
      case SET_MAP_REF:
        map = action.payload
        window._m = map
        return

      case FLY_TO:
        if (!map) {
          return
        }

        map.flyTo(action.payload)
        return
      case SET_VIEW:
        if (!map) {
          return
        }

        map.setView(action.payload)
        return
      case CLEAR_MAP_REF:
        if (window._m) {
          window._m = null
          map = null
        }
        return

      case SET_MAP_ZOOM:
        if (!map) {
          return
        }

        try {
          const [to, ...args] = action.payload

          if (Array.isArray(to)) {
            const isBounds = Array.isArray(to[0])

            if (isBounds) {
              map && map.flyToBounds(to, ...args)
            } else {
              map && map.flyTo(to, ...args)
            }
          }
        } catch (error) {
          console.error(error)
        }
        return

      case FIT_MAP_BOUNDS:
        if (map) {
          return map.fitBounds(action.payload)
        }
        return null

      default:
        dispatch(action)
    }
  }
}
